//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import IconView from "@/components/objects/IconView.vue";
import { datesToHuman } from "@/utils/dates.js";
import { BUILD_STORAGE_IMAGE_PATH } from "@/constants/ui.js";

export default {
  name: "NewEventDetailCard",
  components: {
    IconView,
  },
  props: {
    targetObject: {
      type: Object,
      default: null
    },
    ownerMode: {
      type: Boolean,
      default: false
    },
    shortName: {
      type: Boolean,
      default: false
    },
    showUserName: {
      default: false,
      type: Boolean
    },
    useStorage: {
      type: Boolean
    },
    source: {
      type: String,
    },
  },
  computed: {
    showCounter() {
      return Number.isInteger(this.targetObject.views)
    },
    label() {
      return this.shortName ? this.targetObject.short_label || this.targetObject.label : this.targetObject.label
    },
    hasDates() {
      return this.targetObject.updated_at && this.targetObject.created_at
    },
    // updatedAt() {
    //   const date = new Date(this.targetObject.updated_at)
    //   const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
    //   const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
    //   return `${day}.${month}.${date.getFullYear()}`
    // },
    // createdAt() {
    //   const date = new Date(this.targetObject.created_at)
    //   const day = date.getDate().toLocaleString('ru', { minimumIntegerDigits: 2 })
    //   const month = (date.getMonth() + 1).toLocaleString('ru', { minimumIntegerDigits: 2 })
    //   return `Создано ${day}.${month}.${date.getFullYear()}`
    // },
    staticImageUrl() {
      if (!this.targetObject.has_image) return ""

      if (this.useStorage) {
        return BUILD_STORAGE_IMAGE_PATH(this.targetObject.image)
      } else {
        return `/public/object_images_files/first_image/${this.targetObject.id}/?preview=1`
      }
    }
  },
  methods: {
    getDescription(text) {
      return text.replace(/<\/?[^>]+(>|$)/g, "")
    },
    getDates(event_date) {
      return datesToHuman({
        value: event_date.vfrom,
      }, {
        value: event_date.vto
      }).replace('-', '-<wbr>')
    },
  }
}
